<template lang="pug">
  .deviceTags
    .tag(@dblclick.stop="$emit('editDevice')", v-for='deviceTag in deviceTags', :id="'DeviceTagsShortInfo-tag' + deviceTag.id", :key='deviceTag.id') {{ deviceTag.name }}
</template>

<script>

export default {
  props: ['deviceId'],
  components: {
  },
  created () {
    this.device = this.$store.state.Device.device_list.find(device => {
      return device.id === this.deviceId
    })
  },
  watch: {
    deviceId: function (newVal, oldVal) {
      this.device = this.$store.state.Device.device_list.find(device => {
        return device.id === this.deviceId
      })
    }
  },
  data () {
    return {
      errors: {
      },
      inputVisible: false,
      addTagName: '',
      device: undefined
    }
  },
  methods: {
  },
  computed: {
    deviceTags () {
      // const device = this.$store.state.Device.device_list.find(device => {
      //   return device.id === this.deviceId
      // })
      if (!this.device) return
      const tags = this.$store.state.Device.device_tags.filter(dt => dt.device.includes(this.device.id))
      return tags.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";

.tag {
  padding: 3px;
  margin: 1px;
  white-space: nowrap;
  color: $--color-text-secondary;
  background-color: rgba($--color-primary, 0.6);
  font-size: $--font-size-small;
  border: 1px solid rgba(black, 0.8);
  border-radius: 5px;
  cursor: pointer;
}
.deviceTags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceTagsShortInfo.vue